
import { FIREARM_STORAGE_LOCATION_METADATA } from './firearm-storage-location.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmStorageLocationPLIMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('FirearmStorageLocationPLI', {
      firearmStorageLocationPLIId: <PropertyMetadata> {
        name: 'firearmStorageLocationPLIId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      firearmStorageLocation: <PropertyMetadata> {
        name: 'firearmStorageLocation',
        type: 'FirearmStorageLocation',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_STORAGE_LOCATION_METADATA;
        },
        byReference: true,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      documentUploadedBy: <PropertyMetadata> {
        name: 'documentUploadedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        length: 255,
        unique: false
      },
      hasDocuments: <PropertyMetadata> {
        name: 'hasDocuments',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        length: 1,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      validFromDate: <PropertyMetadata> {
        name: 'validFromDate',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      validToDate: <PropertyMetadata> {
        name: 'validToDate',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.firearmStorageLocationPLIId;
    return nullIfContainsNull(result);
  }
}



